import "./index.css";
import React from "react";
import PropTypes from "prop-types";
import { Modal, Header, Divider } from "semantic-ui-react";
import { Link } from "redux-little-router";
import { loginWithFacebook } from "../../actions/userActions";
import { connect } from "react-redux";

export const SignInModal = ({ isOpen, user, hide, message, actions: { loginWithFacebook } }) => {
  if(user){
    return null;
  } 
  return (
    <Modal size="tiny" onClose={() => hide && hide()} className="user-sign-in-modal" open={isOpen}>
      <Modal.Content>
        <div className="ui one column stackable center aligned page grid">
          <div className="column sixteen wide">
            <b className="modal-p">{message || "Please log in to view this case."}</b>
            <div className="login-buttons">
              <div className="login-button -facebook" onClick={loginWithFacebook}>
                Connect with Facebook
              </div>
              <div className="login-button -primary">
                <Link className="link" href="/signup">
                  Create new account
                </Link>
              </div>
            </div>
          </div>
          <span className="signin-anchor">
            Already have an account?
            <Link href="/signin"> Sign in </Link>
          </span>
        </div>
      </Modal.Content>
      <div className="ui one column stackable center aligned page grid">
        <div className="column sixteen wide">
          <Divider />
        </div>
      </div>
      <Modal.Description size="large">
        <div className="ui one column stackable center aligned page grid">
          <div className="column sixteen wide">
            <Header>Why do I need to sign in?</Header>
            <p className="modal-p">
              Casemasters is a knowledge-sharing community that depends on everyone being able to pitch in when they
              know something.
            </p>
            <br />
          </div>
        </div>
      </Modal.Description>
    </Modal>
  );
};

SignInModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

const mapDispatchToProps = dispatch => ({
  actions: {
    loginWithFacebook: () => dispatch(loginWithFacebook()),
  },
});

export default connect(null, mapDispatchToProps)(SignInModal);



// WEBPACK FOOTER //
// ./src/components/SignInModal/index.js